import Map from "./Map/Map";
import {useContext, useEffect, useState, useRef} from "react";
import Prices from "./Prices/Prices";
import {ZonesContext, LabelsContext} from "./AppContext";
import {} from "./AppContext";

function App(props) {
    const [products, setProducts] = useState(null);
    const zonesState = useContext(ZonesContext);
    const labelContext = useContext(LabelsContext);
    const pricingTable = useRef(null)

    useEffect(() => {
        const fetchData = async () => {
            const data = await (
                await fetch(props.productUrl)
            ).json();

            setProducts(data);
        }

        fetchData();
    }, []);

    window.addEventListener('scroll', (event) => {
      if (document.getElementById('page-map-zone-2')) {
        const pricingTableDistance = document.getElementById('page-map-zone-2').offsetTop + 582
        const currentDistance = document.documentElement.scrollTop
        if (currentDistance >= pricingTableDistance) {
          document.getElementById('pricing-table-button').classList.remove('active')
        }
      }
    })

    const positionHelper = () => {
      const svg = document.querySelector('.map-wrapper svg')
      const zone = svg?.querySelector('[data-zone="10"]')
      const helper = document.querySelector('.map-wrapper .helper')
      const wrapper = document.querySelector('.map-wrapper')

      if (!svg || !zone || !helper || !wrapper) return

      const zoneRect = zone.getBoundingClientRect()
      const wrapperRect = wrapper.getBoundingClientRect()

      const top = zoneRect.top - wrapperRect.top - 88
      const left = zoneRect.left - wrapperRect.left + (zoneRect.width - helper.offsetWidth) / 2

      Object.assign(helper.style, {
        position: 'absolute',
        top: `${top}px`,
        left: `${left}px`
      })
    }

  const waitForRender = () => {
    const svg = document.querySelector('.map-wrapper svg')
    const zone = svg?.querySelector('[data-zone="10"]')
    const helper = document.querySelector('.map-wrapper .helper')
    const wrapper = document.querySelector('.map-wrapper')

    if (!svg || !zone || !helper || !wrapper || helper.offsetWidth === 0) {
      return setTimeout(waitForRender, 50)
    }

    positionHelper()
  }

  window.addEventListener('load', waitForRender)

  window.addEventListener('resize', positionHelper)

  const handleClick = () => {
      pricingTable.current?.scrollIntoView({behavior: 'smooth'});
      document.getElementById('pricing-table-button').classList.remove('active')
    };

    const hasZone = Object.keys(zonesState.selectedZones).length > 0
    const hasMultipleZones = Object.keys(zonesState.selectedZones).length > 1
    const allZones = Object.keys(zonesState.selectedZones).length === 7

    const mapLayout = document.getElementById('tx-mrfrimobilprices')

    return (
        <div className="App">
            {
                products !== null ?
                    <>
                        { mapLayout.classList.contains('layout-9') ? (
                            <>
                              <div className={'page-map-zone-1'}>
                                <div className={'container-fluid'}>
                                  <div className={'row'}>
                                    <div className={'col-12 col-lg-6 col-first'}>
                                      <Map zones={zonesState.zones} />
                                    </div>
                                    <div className={'col-12 col-lg-5 offset-lg-1 col-second'}>
                                      { Object.keys(zonesState.selectedZones).length > 0 ? (
                                        <div>
                                          <h2>
                                            { hasMultipleZones ? (
                                              allZones ? labelContext.getLabel('allZones') : labelContext.getLabel('selectedZones') + ' '
                                            ) : (
                                              labelContext.getLabel('selectedZone') + ' '
                                            )
                                            }
                                            { allZones ? (
                                              ''
                                            ) : (
                                              Object.keys(zonesState.selectedZones).map((zoneId, zone) => {
                                                return zoneId
                                              }).join(', ')
                                            )
                                            }
                                          </h2>
                                          <p className={'h2-subheader small'}>
                                            {labelContext.getLabel('validity')}
                                          </p>
                                          { Object.entries(products).map(([index, product]) => {
                                            return <Prices product={product} />
                                          })
                                          }
                                        </div>
                                      ) : ('')
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className={'page-map-zone-1'}>
                                <div className={'container-fluid'}>
                                  <div className={'row'}>
                                    <div className={'col-12 col-lg-6 offset-lg-5'}>
                                      <Map zones={zonesState.zones} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              { Object.keys(zonesState.selectedZones).length > 0 ? (
                                <div id={'page-map-zone-2'} className={'page-map-zone-2'} ref={pricingTable}>
                                  <div className={'container-fluid'}>
                                    <div className={'col-12'}>
                                      <h2>
                                        { hasMultipleZones ? (
                                          allZones ? labelContext.getLabel('allZones') : labelContext.getLabel('selectedZones') + ' '
                                        ) : (
                                          labelContext.getLabel('selectedZone') + ' '
                                        )
                                        }
                                        { allZones ? (
                                          ''
                                        ) : (
                                          Object.keys(zonesState.selectedZones).map((zoneId, zone) => {
                                            return zoneId
                                          }).join(', ')
                                        )
                                        }
                                      </h2>
                                      <p className={'h2-subheader small'}>
                                        {labelContext.getLabel('validity')}
                                      </p>
                                      { Object.entries(products).map(([index, product]) => {
                                        return <Prices product={product} />
                                      })
                                      }
                                    </div>
                                  </div>
                                </div>
                              ) : ('')
                              }
                              <div id={'pricing-table-button'} className={hasZone ? 'pricing-table-button-container active' : 'pricing-table-button-container'} onClick={handleClick}>
                                <div className={'container-fluid'}>
                                  <div className={'row'}>
                                    <div className={'col-12'}>
                                        <span>
                                            {labelContext.getLabel('pricing-table-button')}
                                          <i className={'frimobil-icons icon-arrow'}></i>
                                        </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )
                        }
                    </>
                    : <></>
            }
        </div>
    );
}

export default App;
